import { render, staticRenderFns } from "./SupplierBarcodes.vue?vue&type=template&id=15edffea&scoped=true&"
import script from "./SupplierBarcodes.vue?vue&type=script&lang=js&"
export * from "./SupplierBarcodes.vue?vue&type=script&lang=js&"
import style0 from "./SupplierBarcodes.vue?vue&type=style&index=0&id=15edffea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15edffea",
  null
  
)

export default component.exports